import { useState, useRef } from 'react';
import { Globe } from 'lucide-react';
import { useClickOutside } from '../../hooks/useClickOutside';
import { cn } from '../../utils/cn';

const languages = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'hi', label: 'हिंदी', flag: '🇮🇳' },
];

export default function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('en');
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false));

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
        title="Language"
      >
        <Globe size={18} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-50 w-36 rounded-lg border border-border bg-surface-card py-1 shadow-lg">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setActive(lang.code);
                setOpen(false);
              }}
              className={cn(
                'flex w-full items-center gap-2 px-3 py-2 text-sm transition-colors',
                active === lang.code
                  ? 'bg-primary-light text-primary font-medium'
                  : 'text-content-secondary hover:bg-surface-card-hover'
              )}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
